import { EnvironmentEncoderAdapter } from '@/infra/criptography'

export const makeEncoderAdapterFactory = (): EnvironmentEncoderAdapter => new EnvironmentEncoderAdapter()
